import GenericView from "@/views/GenericView.vue"
import { mapGetters, mapMutations } from "vuex"
import { getSas } from "@/plugins/services/sas"
import { getContextWithToken } from "@/plugins/services/auth"
import { submitSas } from "@/plugins/services/sas"
import { mapActions } from "vuex"
import DataIteratorValidator from "./DataIteratorValidator"

export default {
  props: {
    step: {
      type: String,
    },
  },

  mixins: [DataIteratorValidator],

  data() {
    return {
      formulaireNonValide: false,
      estFormulairePublic: false,
    }
  },

  components: {
    GenericView,
  },

  created() {
    this.createdMethod()
  },

  computed: {
    ...mapGetters(["sas", "panier"]),

    realSteps() {
      return this.steps.filter(
        (s) => s.path != "introduction" && s.path != "soumission"
      )
    },

    currentStep() {
      return this.findStep(this.step)
    },

    canSubmit() {
      return this.steps.every((s) => s.state == "success")
    },
  },

  methods: {
    ...mapMutations(["SET_CONTACTID", "SET_SAS"]),
    ...mapActions(["fetchPanier"]),

    async createdMethod() {
      // On reset le sas du store pour s'assurer qu'on a pas conservé les données d'un formulaire précédent.
      this.SET_SAS(null)
      this.checkStep()
      await this.loadToken()
      this.loadParams(this.paramsName)
      if (this.estFormulairePublic || this.loadContact()) {
        this.loading = true
        if (await this.loadSas()) {
          if (this.loadPanierOnLoad && this.sas.id) {
            this.fetchPanier(this.sas.id)
          }
        }
        this.loading = false
      }
    },

    checkStep() {
      if (this.steps.map((s) => s.path).indexOf(this.step) == -1) {
        this.firstStep()
      }
    },
    async loadToken() {
      if (this.$route.query.token) {
        const token = this.$route.query.token.replace(/\s/g, "+")
        const encodedToken = encodeURIComponent(token)
        try {
          let result = await getContextWithToken(encodedToken)
          if (result.data.success) {
            const contactId = result.data.contactId
            this.$router.replace({
              path:
                this.url +
                this.steps[this.steps.findIndex((s) => s.path == this.step) + 1]
                  .path,
              query: { contactId },
            })
          } else {
            throw "Unauthorized"
          }
        } catch (error) {
          this.$router.push({ name: "Unauthorized" })
        }
      }
    },
    loadContact() {
      if (this.$route.query.contactId) {
        this.SET_CONTACTID(this.$route.query.contactId)
        return true
      } else {
        this.$router.push({ name: "NoContactId" })
        return false
      }
    },

    async loadSas() {
      let result = false
      if (this.$route.query.sasId) {
        result = await getSas(this.url, this.$route.query.sasId).then((res) => {
          if (res.data.erreur) {
            this.$router.push({ path: "/formulaire-deja-soumis" })
            return false
          } else {
            this.SET_SAS(res.data)
            return true
          }
        })
      } else {
        if (!this.$route.fullPath.includes(this.steps[0].path)) {
          this.firstStep()
        }
        result = false
      }
      return result
    },

    firstStep() {
      this.$router.push({
        path: this.url + this.steps[0].path,
        query: this.$route.query,
      })
    },

    next() {
      this.validateStep(this.currentStep)
      if (!this.panier && this.loadPanierOnLoad) {
        this.fetchPanier(this.sas.id)
      }
      this.$vuetify.goTo(0)
      this.formulaireNonValide = false
      this.$router.push({
        path:
          this.url +
          this.steps[this.steps.findIndex((s) => s.path == this.step) + 1].path,
        query: { ...this.$route.query },
      })
    },

    setState(step, state) {
      this.findStep(step).state = state ? "success" : "warning"
    },

    findStep(step) {
      return this.steps.find((s) => s.path == step)
    },

    validate() {
      let ok = true
      for (let i = 0; i < this.steps.length; i++) {
        ok = this.validateStep(this.steps[i]) && ok
      }
      return ok
    },

    validateStep(step) {
      let stepValid = true

      let stepRefs = this.$refs[step.path]
      if (stepRefs) {
        let stepRef = undefined
        if (stepRefs.length == 1) {
          stepRef = stepRefs[0]
        } else {
          stepRef = stepRefs
        }
        let stepMainForm = stepRef.$refs.mainForm
        if (stepMainForm) {
          const mainFormValid = stepMainForm.validate()
          stepValid = stepValid && mainFormValid
        }
        const dataIteratoValid = this.validateDataIterator(stepRef.$refs.dataIterator)
        stepValid = stepValid && dataIteratoValid

        let nestedDataIterators = Object.keys(stepRef.$refs).filter(r => r.startsWith("dataIterator") && r !== "dataIterator")
        nestedDataIterators.forEach(key => {
          const ref = stepRef.$refs[key]
          const dataIterator = ref?.$refs?.dataIterator ?? (Array.isArray(ref) ? ref[0] : undefined)
          const nestedDataIteratorValid = this.validateDataIterator(dataIterator)
          stepValid = stepValid && nestedDataIteratorValid
        })
      }
      return stepValid
    },
    submit() {
      this.formulaireNonValide = false
      if (this.validate()) {
        this.loading = true
        submitSas(this.sas.id)
          .then((res) => {
            if (res.data.traite) {
              this.$router.push({
                name: "FormulaireTraite",
                params: { idFacture: res.data.facture },
              })
            } else {
              this.$router.push({
                name: "FormulaireSoumis",
                params: { idFacture: res.data.facture },
              })
            }
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.formulaireNonValide = true
      }
    },
  },
  mounted() {
    if (this.sas) {
      this.findStep("introduction").state = "success"
    }
  },
}
